import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupInputMessageVue = _resolveComponent("GroupInputMessageVue")!
  const _component_MessagesVue = _resolveComponent("MessagesVue")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_GroupMembersVue = _resolveComponent("GroupMembersVue")!
  const _component_AddUserVue = _resolveComponent("AddUserVue")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Grupo " + _toDisplayString(_ctx.currentGroup.groupname), 1),
    _createVNode(_component_b_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_tabs, {
          "active-nav-item-class": "m-2 h-3 list-group-item-success",
          "content-class": "mt-3",
          justified: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_tab, {
              title: "Mensajes del grupo",
              active: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_GroupInputMessageVue),
                _hoisted_2,
                _createVNode(_component_MessagesVue)
              ]),
              _: 1
            }),
            _createVNode(_component_b_tab, { title: "Miembros del grupo" }, {
              default: _withCtx(() => [
                _createVNode(_component_GroupMembersVue)
              ]),
              _: 1
            }),
            _createVNode(_component_b_tab, { title: "Añadir un usuario al grupo" }, {
              default: _withCtx(() => [
                _createVNode(_component_AddUserVue)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}